import { useContext } from 'react';
import { SidebarMenuContext } from '../SidebarMenu';
export const useSidebarMenu = () => {
    const context = useContext(SidebarMenuContext);
    if (!context) {
        throw new Error('useSidebarMenu must be used as a child to <SidebarMenu />');
    }
    return context;
};
